import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import { ReferenceData } from '../types/reference-data';
import { ReferenceDataActions } from './reference-data.actions';

export interface ReferenceDataState extends EntityState<ReferenceData> {
  loading: boolean;
  error: unknown | null;
}

export const referenceDataAdapter = createEntityAdapter<ReferenceData>({
  selectId: (entity) => entity.uuid,
  sortComparer: (a, b) => (a.name || '').localeCompare(b.name || ''),
});

const initialState: ReferenceDataState = referenceDataAdapter.getInitialState({
  loading: false,
  error: null,
});

const reducer = createReducer(
  initialState,

  on(ReferenceDataActions.loadAll, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(ReferenceDataActions.loadAllSuccess, (state, { items }) =>
    referenceDataAdapter.setAll(items ?? [], {
      ...state,
      loading: false,
      error: null,
    })
  ),

  on(ReferenceDataActions.loadAllFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);

export const referenceDataFeature = createFeature({
  name: 'referenceData',
  reducer,
});

export const {
  selectAll: selectAllReferenceData,
  selectEntities: selectReferenceDataEntities,
  selectIds: selectReferenceDataIds,
  selectTotal: selectReferenceDataTotal,
} = referenceDataAdapter.getSelectors(referenceDataFeature.selectReferenceDataState);
